import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import { Tune } from '@mui/icons-material';

import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import Inventory from '@mui/icons-material/Inventory';

import ManageUsers from './ManageUsers';
import ManagePackages from './ManagePackages';
import { dummyFeatures, dummyPackages } from '../../data/packages';
import dummyUsers from '../../data/users';
import ManageFeatures from './ManageFeatures';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pl: 3, pt: 1 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
};

const Settings = () => {
  const [value, setValue] = useState(0);
  const [users, setUsers] = useState(dummyUsers);
  const [packages, setPackages] = useState(dummyPackages);
  const [packageFeatures, setPackageFeatures] = useState(dummyFeatures);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // ToDo: Fetch Packages as well.
  //useEffect(() => {
  // if (!isAuthenticated()) {
  //   navigate('/login');
  //   return;
  // }

  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const [usersData, companiesData] = await Promise.all([
  //       getUsers(),
  //       getAllCompanies(),
  //     ]);

  //     setUsers(usersData.data || []);
  //     setCompanies(companiesData.data || []);
  //     setLastKey(companiesData.lastKey || null);
  //   } catch (err) {
  //     console.error('Failed to fetch data:', err);
  //     if (err.response?.status === 401) {
  //       navigate('/login');
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // fetchData();
  //updateCompanyWithUserNames();
  //updateStats();
  //}, []);

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <Paper elevation={3}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Settings tabs"
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            minWidth: 200,
            '& .MuiTab-root': {
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'row',
              padding: '16px 16px',
              minHeight: '48px',
              textTransform: 'none',
              fontSize: '0.875rem',
              '& .MuiTab-iconWrapper': {
                marginRight: '8px',
              },
              '& .MuiTab-wrapper': {
                width: '100%',
                textAlign: 'center',
                marginLeft: '-24px',
              },
            },
          }}
        >
          <Tab
            label="Users"
            icon={<SupervisorAccount />}
            iconPosition="start"
            {...a11yProps(0)}
          />
          <Tab
            label="Features"
            icon={<Tune />}
            iconPosition="start"
            {...a11yProps(2)}
          />
          <Tab
            label="Packages"
            icon={<Inventory />}
            iconPosition="start"
            {...a11yProps(1)}
          />
        </Tabs>
      </Paper>

      <Box sx={{ flexGrow: 1 }}>
        <TabPanel value={value} index={0}>
          <ManageUsers users={users} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ManageFeatures allFeatures={dummyFeatures} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ManagePackages packages={packages} features={dummyFeatures} />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default Settings;
